import AppModal from "../../components/AppModal";
import React, {memo} from "react";
import backgroundModal from "../../assets/img/faqpanel-bar.png";
import {VideoTypes} from "./BallroomPage";

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '28vw',
        maxWidth: '28vw',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        border: '0px',
        background: '',
        padding: "3px 3px",
        textAlign: "center",
        backgroundSize: "100% 100%",
        alignItems: "center",
        overflow: "hidden",
        backgroundImage: `url(${backgroundModal})`,
        backgroundColor: '#000000d4'
    },
    overlay: {
        zIndex: 900,
    }
};

const BallroomModal = ({open, onClose, onOk, videoType}) => {
    return (<AppModal
        isOpen={open}
        propsStyle={customStyles}
        contents={
            <div className={'modal-content'}>
                {/*<div className={'modal-header'}>*/}
                {/*    {videoType === VideoTypes.PANEL && <div className="header-ballroom-modal">Up next: Panel Discussion</div>}*/}
                {/*    {videoType === VideoTypes.AWARD && <div className="header-ballroom-modal">Up next: Award Presentation</div>}*/}
                {/*    <div className='close-button-ballroom-modal' onClick={onClose}>X</div>*/}
                {/*</div>*/}
                {/*{videoType === VideoTypes.PANEL &&*/}
                {/*<div className="modal-body-discussion">*/}
                {/*    Please click the button below to proceed.*/}
                {/*</div>}*/}
                <div className="modal-body-discussion">
                    <p style={{margin: 0}}>This page is no longer available for </p>
                    <p style={{margin: 0}}>this on-demand site.</p>
                </div>
                {/*{videoType === VideoTypes.AWARD &&*/}
                {/*<div className={'modal-body'}>*/}
                {/*    <p>Please click the button below to proceed.</p>*/}
                {/*</div>}*/}
                <div className="modal-bottom">
                    <button className="modal-ok-btn-ballroom" onClick={onOk}>Ok</button>
                </div>
            </div>
        }
    />)
}

export default memo(BallroomModal)